import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Monthly_navbar from "./Monthlytasks_navbar";
import RightsCheck from "../General/RightsCheck";
import config from "../../Config";

const MONTH_OPTIONS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

function yearOptions() {
  const y = new Date().getFullYear();
  const opts = [];
  for (let i = y - 5; i <= y + 2; i++) {
    opts.push(i);
  }
  return opts;
}

const fmtNum = (v) => {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

function FeeAbstractReport() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const now = new Date();
  const prevPeriod = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const [month1, setMonth1] = useState(now.getMonth() + 1);
  const [year1, setYear1] = useState(now.getFullYear());
  const [month2, setMonth2] = useState(prevPeriod.getMonth() + 1);
  const [year2, setYear2] = useState(prevPeriod.getFullYear());

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    document.title = "Fee Abstract";
  }, []);

  const loadReport = () => {
    setLoading(true);
    setRows([]);
    setMeta(null);

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/GetFeeAbstractReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Admin",
        SchoolID: 1,
        SelectedMonth: month1,
        FYear: year1,
        CompareMonth: month2,
        CompareYear: year2,
      },
      timeout: 120000,
    })
      .then((res) => {
        if (res.data?.status_code === 1) {
          setRows(res.data.CompareRows || []);
          setMeta({
            period1Label: res.data.Period1_Label,
            period2Label: res.data.Period2_Label,
            prefix1: res.data.Period1_ChallanPrefix,
            prefix2: res.data.Period2_ChallanPrefix,
            t1Posted: res.data.Period1_TotalFeePosted,
            t2Posted: res.data.Period2_TotalFeePosted,
            t1Arrears: res.data.Period1_TotalArrears,
            t2Arrears: res.data.Period2_TotalArrears,
            t1Concession: res.data.Period1_TotalConcession,
            t2Concession: res.data.Period2_TotalConcession,
            t1Receiveable: res.data.Period1_TotalReceiveable,
            t2Receiveable: res.data.Period2_TotalReceiveable,
          });
        } else {
          toast.error(res.data?.status_message || "Report failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setLoading(false));
  };

  const printUrl = `/MonthlyTasks/PrintFeeAbstractReport?m1=${month1}&y1=${year1}&m2=${month2}&y2=${year2}`;

  return (
    <>
        <Monthly_navbar />
        <RightsCheck />
        <ToastContainer />
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/Dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/MonthlyTasks/MonthlyTasksDashboard">Monthly Task</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Fee Abstract
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Fee Abstract</div>
                <p className="text-muted small mb-0">
                  Compare fee heads from challan periods (filter by structured challan prefix{" "}
                  <strong>YYMM</strong>). Student counts are per fee type only; totals do not sum
                  students across fee heads.
                </p>
              </div>
              <div className="col-md-4">
                <div className="page-right-actions d-flex flex-wrap justify-content-md-end gap-2">
                  <Link
                    target="_blank"
                    to={printUrl}
                    className="button button-white button-icon"
                  >
                    Print
                    <i className="ri-printer-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card mb-3">
              <div className="card-body p-md-4">
                <div className="row g-3 align-items-end">
                  <div className="col-12">
                    <strong>Period 1</strong>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Month</label>
                    <select
                      className="form-select"
                      value={month1}
                      onChange={(e) => setMonth1(parseInt(e.target.value, 10))}
                    >
                      {MONTH_OPTIONS.map((m) => (
                        <option key={`p1m-${m.value}`} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Year</label>
                    <select
                      className="form-select"
                      value={year1}
                      onChange={(e) => setYear1(parseInt(e.target.value, 10))}
                    >
                      {yearOptions().map((y) => (
                        <option key={`p1y-${y}`} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 mt-2">
                    <strong>Period 2</strong>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Month</label>
                    <select
                      className="form-select"
                      value={month2}
                      onChange={(e) => setMonth2(parseInt(e.target.value, 10))}
                    >
                      {MONTH_OPTIONS.map((m) => (
                        <option key={`p2m-${m.value}`} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Year</label>
                    <select
                      className="form-select"
                      value={year2}
                      onChange={(e) => setYear2(parseInt(e.target.value, 10))}
                    >
                      {yearOptions().map((y) => (
                        <option key={`p2y-${y}`} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <button
                      type="button"
                      className="button button-primary w-100"
                      disabled={loading}
                      onClick={loadReport}
                    >
                      {loading ? (
                        <>
                          <Spinner size="sm" animation="border" className="me-2" />
                          Loading…
                        </>
                      ) : (
                        "View comparison"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {meta ? (
              <p className="text-muted small mb-2">
                Challan filters: <code>{meta.prefix1}%</code> ({meta.period1Label}) vs{" "}
                <code>{meta.prefix2}%</code> ({meta.period2Label})
              </p>
            ) : null}

            <div className="card mt-1">
            <div className="card-body table-responsive p-0">
              <table className="table table-bordered table-sm mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th rowSpan={2}>Fee code</th>
                    <th rowSpan={2}>Fee type</th>
                    <th colSpan={5} className="text-center">
                      {meta?.period1Label || "Period 1"}
                    </th>
                    <th colSpan={5} className="text-center">
                      {meta?.period2Label || "Period 2"}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-end">Students</th>
                    <th className="text-end">Fee posted (Rs.)</th>
                    <th className="text-end">Arrears (Rs.)</th>
                    <th className="text-end">Concession (Rs.)</th>
                    <th className="text-end">Receiveable (Rs.)</th>
                    <th className="text-end">Students</th>
                    <th className="text-end">Fee posted (Rs.)</th>
                    <th className="text-end">Arrears (Rs.)</th>
                    <th className="text-end">Concession (Rs.)</th>
                    <th className="text-end">Receiveable (Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={12} className="text-center py-4">
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : rows.length === 0 ? (
                    <tr>
                      <td colSpan={12} className="text-center text-muted py-4">
                        {meta
                          ? "No fee lines match the selected periods."
                          : "Select two periods and click View comparison."}
                      </td>
                    </tr>
                  ) : (
                    rows.map((r, i) => (
                      <tr key={`${r.FeeCode}-${i}`}>
                        <td>{r.FeeCode}</td>
                        <td>{r.Fee_Type_Name || "—"}</td>
                        <td className="text-end">{fmtNum(r.Period1_TotalStudent)}</td>
                        <td className="text-end">{fmtNum(r.Period1_FeePosted)}</td>
                        <td className="text-end">{fmtNum(r.Period1_Arrears)}</td>
                        <td className="text-end">{fmtNum(r.Period1_Concession)}</td>
                        <td className="text-end">{fmtNum(r.Period1_Receiveable)}</td>
                        <td className="text-end">{fmtNum(r.Period2_TotalStudent)}</td>
                        <td className="text-end">{fmtNum(r.Period2_FeePosted)}</td>
                        <td className="text-end">{fmtNum(r.Period2_Arrears)}</td>
                        <td className="text-end">{fmtNum(r.Period2_Concession)}</td>
                        <td className="text-end">{fmtNum(r.Period2_Receiveable)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                {rows.length > 0 && meta ? (
                  <tfoot className="table-light">
                    <tr>
                      <th colSpan={2}>Totals</th>
                      <th className="text-end">—</th>
                      <th className="text-end">{fmtNum(meta.t1Posted)}</th>
                      <th className="text-end">{fmtNum(meta.t1Arrears)}</th>
                      <th className="text-end">{fmtNum(meta.t1Concession)}</th>
                      <th className="text-end">{fmtNum(meta.t1Receiveable)}</th>
                      <th className="text-end">—</th>
                      <th className="text-end">{fmtNum(meta.t2Posted)}</th>
                      <th className="text-end">{fmtNum(meta.t2Arrears)}</th>
                      <th className="text-end">{fmtNum(meta.t2Concession)}</th>
                      <th className="text-end">{fmtNum(meta.t2Receiveable)}</th>
                    </tr>
                  </tfoot>
                ) : null}
              </table>
            </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default FeeAbstractReport;
